import React from 'react';

// Use for buttons with TEXT ONLY hover effects

const ButtonHoverText = ({
  onEnter,
  onLeave,
  hovering,
  children,
  color,
  hoverTextColor,
  handleClick,
  ...rest
}) => {
  const styles = hovering ? { color: hoverTextColor } : { color };
  return (
    <button
      style={styles}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </button>
  );
};

export default ButtonHoverText;
